import { render, staticRenderFns } from "./faqEc.vue?vue&type=template&id=e58392a6&scoped=true"
import script from "./faqEc.vue?vue&type=script&lang=js"
export * from "./faqEc.vue?vue&type=script&lang=js"
import style0 from "./faqEc.vue?vue&type=style&index=0&id=e58392a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58392a6",
  null
  
)

export default component.exports